import React from 'react';
import { Button, Flex } from '@zillow/constellation';
import { useCustomViewsContext } from '../../context/CustomViewsContext';

export const UpdateFooter: React.FC = () => {
  const {
    customViewsState: { formikData },
    setCustomViewsState,
  } = useCustomViewsContext();
  const disabled = !(formikData?.dirty && formikData?.isValid);
  return (
    <Flex display={'flex'} flexDirection={'row-reverse'} gap={'xs'} alignItems={'center'}>
      <Button buttonType={'primary'} type={'submit'} form={'update-custom-view-form'} disabled={disabled}>
        Update custom view
      </Button>
      <Button
        buttonType={'secondary'}
        onClick={() =>
          setCustomViewsState((prev) => ({ ...prev, updatingView: null, formikData: null, isCreate: false }))
        }
        type={'button'}
      >
        Cancel
      </Button>
    </Flex>
  );
};
